(function ($) {
    "use strict";

    // The native <select>'s own open dropdown list can't be styled
    // consistently cross-browser, so it gets progressively enhanced into a
    // "Rendezés: <label>" button + listbox — same approach as
    // 36_pm-property-filter.js / 39_pm-lead-form-modal.js. The native
    // <select> stays around (visually hidden) purely to carry the value/
    // name for whatever real sorting eventually reads it (see
    // pm_property_results.php — no real sort/filtering wired up yet).
    function enhanceSortSelect($wrap) {
        var $select = $wrap.find(".pm-property-results__sort-select");

        if (!$select.length || $wrap.data("pm-sort-enhanced")) {
            return;
        }

        $wrap.data("pm-sort-enhanced", true);

        // Before a real option is picked, the trigger shows the ACF
        // "Sort label" default (e.g. "Alap") instead of the native
        // select's own (empty) placeholder option text.
        var defaultLabel = $wrap.data("default-label") || "";
        var $triggerLabel = $("<span>", { text: defaultLabel });
        var $trigger = $("<button>", {
            type: "button",
            class: "pm-property-results__sort-label",
            "aria-haspopup": "listbox",
            "aria-expanded": "false",
        }).append(document.createTextNode("Rendezés: "), $triggerLabel);

        var $list = $("<ul>", {
            class: "pm-property-results__sort-list",
            role: "listbox",
        }).attr("hidden", true);

        $select.find("option").each(function () {
            var $option = $(this);

            if (!$option.attr("value")) {
                return;
            }

            var $item = $("<li>", {
                class: "pm-property-results__sort-option",
                role: "option",
                tabindex: "-1",
                text: $option.text(),
            }).attr("data-value", $option.attr("value"));

            if ($option.is(":selected")) {
                $item.addClass("is-selected");
            }

            $list.append($item);
        });

        $select
            .attr("tabindex", "-1")
            .attr("aria-hidden", "true")
            .addClass("pm-property-results__sort-select--native-hidden");

        $wrap.append($trigger, $list);

        function closeList() {
            $list.attr("hidden", true);
            $trigger.attr("aria-expanded", "false");
        }

        function openList() {
            $(".pm-property-results__sort-list").not($list).attr("hidden", true);
            $(".pm-property-results__sort-label").not($trigger).attr("aria-expanded", "false");
            $list.removeAttr("hidden");
            $trigger.attr("aria-expanded", "true");
        }

        function selectOption($item) {
            $list.find(".is-selected").removeClass("is-selected");
            $item.addClass("is-selected");
            $triggerLabel.text($item.text());
            $select.val($item.attr("data-value")).trigger("change");
        }

        $trigger.on("click", function (e) {
            e.stopPropagation();

            if ($list.attr("hidden")) {
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-property-results__sort-option").first()).trigger("focus");
            } else {
                closeList();
            }
        });

        $list.on("click", ".pm-property-results__sort-option", function () {
            selectOption($(this));
            closeList();
            $trigger.trigger("focus");
        });

        $list.on("keydown", ".pm-property-results__sort-option", function (e) {
            var $items = $list.find(".pm-property-results__sort-option");
            var index = $items.index(this);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                $items.eq(Math.min(index + 1, $items.length - 1)).trigger("focus");
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                $items.eq(Math.max(index - 1, 0)).trigger("focus");
            } else if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                selectOption($(this));
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Escape") {
                e.preventDefault();
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Tab") {
                closeList();
            }
        });

        $trigger.on("keydown", function (e) {
            if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-property-results__sort-option").first()).trigger("focus");
            }
        });
    }

    $(function () {
        $(".js-pm-property-results-sort-select-wrap").each(function () {
            enhanceSortSelect($(this));
        });

        $(document).on("click", function () {
            $(".pm-property-results__sort-list").attr("hidden", true);
            $(".pm-property-results__sort-label").attr("aria-expanded", "false");
        });
    });
})(jQuery);
